import { gql } from '@apollo/client/core';

// eslint-disable-next-line import/prefer-default-export
export const ALL_NOTIFICATIONS = gql`
  query paginatedNotifications($first: Int, $after: String, $isReaded: Boolean, $dateRange: [String], $search: String) {
    paginatedNotifications(first: $first, after: $after, isReaded: $isReaded, dateRange: $dateRange, search: $search) {
      totalCount
      endCursor
      pageNumber
      totalPages
      hasNextPage
      totalCountInDb
      totalUnreaded
      results{
        id
        uuid
        title
        body
        isReaded
        actionUrl
        createdAt
      }
    }
  }
`;
